<template>
  <div>
    <div class="seachBox flex">
      <div class="seachList"><span class="name">一级维度：</span>
        <a-select v-model="seach.type" class="seachs" placeholder="请选择" allowClear @change="getList(1)">
          <a-select-option :value="item.id" :key="item.id" v-for="item in seachList">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList  ">
        <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
          查询
        </a-button>
        <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
      </div>
      <div class="seachList no"></div>
      <div class="seachList no"></div>
      <div class="seachList no"></div>
    </div>
    <a-button class="top_btn" type="primary" @click="()=>{  visible = true; title='添加指令'; typeId=this.seach.type }"  > 添加
    </a-button>
    <p style="color: #f00">注：{keyword}表示匹配筛选出来的关键词，{industry_category}表示客户前台填的“行业”,{company_name}调取的为响贝超管的客户名称，{brand_keywords}表示客户前台填的“品牌词“，{core_business_goal}表示客户前台填的“核心业务目标”、{target_audience}表示客户前台填的“采购群体画像”，{language}表示客户前台选的“着陆页内容语言”，{Template_dec}表示着陆页生成确认时选择的模板，{product_name}表示客户前台选择的产品名称，{product_dec}表示客户前台选择的产品-对应的产品描述，{product_category_name}表示客户前台选择的产品分类名称，{product_category_dec1}表示客户前台选择的产品分类-对应的列表描述（上），{product_category_dec2}表示客户前台选择的产品分类-对应的列表描述（下）</p>

    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" :scroll="{ x: 2000 }">
          <span slot="type" slot-scope="text, record">
              <span v-if="text==1">产品展示类型</span>
              <span v-else-if="text==2">解决方案类型</span>
              <span v-else-if="text==3">采购商类型</span>
              <span v-else-if="text==4">话题类型</span>
              <span v-else-if="text==5">用途类型</span>
              <span v-else-if="text==6">服务类型</span>
              <span v-else-if="text==7">着陆页生成</span>
              <span v-else-if="text==8">着陆页优化-产品</span>
              <span v-else-if="text==9">着陆页优化-产品分类(上)</span>
              <span v-else-if="text==10">着陆页优化-产品分类（下）</span>
          </span>
            <span slot="status" slot-scope="text, record">
                <a-switch @click="onChange(record)" :checked="text==1?true:false" />
            </span>
      <span slot="action" slot-scope="text, record">
                <a @click="(record)=>{visible = true;  title='编辑指令'; editId=text.id ; typeId=text.type }" >编辑</a>
            </span>
    </a-table>
    <a-pagination
        :current="pagination.current"
        :total="pagination.total"
        :pageSize="pagination.pageSize"
        :showSizeChanger="true"
        :showQuickJumper="true"
        :showTotal="(total, range) => `共 ${total} 条`"
        @change="getList"
        @showSizeChange="onShowSizeChange"
        style="margin-top: 20px; text-align: right;"
    />
    <InstructionForm :visible="visible" :title="title" :editId="editId" :typeId="typeId"
                     @changVisible=" () => { this.visible = false;this.editId='';this.typeId=''; this.getList()}  "/>
  </div>
</template>

<script>
import API from "./api";
import moment from 'moment';
import InstructionForm from "./components/instructionForm"
import {changStatus, removeById,orderList} from "../../../utils/utils"
export default {
  name: "googleAdslandingPage",
  data() {
    return {
      seach: {
        type: 1,
      },
      pagination: {
        pageNo: 1,
        pageSize: 20,
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize),
        onChange: this.getList.bind(this),
        total: 0,
        current: 1,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      seachList:[
        {id:1, name: "产品展示类型"},
        {id:2, name: "解决方案类型"},
        {id:3, name: "采购商类型"},
        {id:4, name: "话题类型"},
        {id:5, name: "用途类型"},
        {id:6, name: "服务类型"},
        {id:7, name: "着陆页生成"},
        {id:8, name: "着陆页优化-产品"},
        {id:9, name: "着陆页优化-产品分类(上)"},
        {id:10, name: "着陆页优化-产品分类（下）"},
      ],
      data: [],
      loading: true,
      visible: false,
      title: "",
      editId: null,
      typeId: null
    }
  },
  computed: {
    columns() {
      // 先获取动态列
      const dynamicColumns = this.getDynamicColumns();
      // 返回完整列配置
      return [
        {
          title: "序号",
          dataIndex: "id",
          key: "id",
          width: "80px",
        },
        {
          title: "一级维度",
          dataIndex: "type",
          ellipsis: true,
          key: "type",
          scopedSlots: {customRender: "type"},
          width: "150px",
        },
        ...dynamicColumns, // 动态列
        {
          title: "状态",
          key: "status",
          width: "80px",
          dataIndex: "status",
          scopedSlots: {customRender: "status"}
        },
        {
          title: "添加时间",
          dataIndex: "create_time",
          key: "create_time",
          width: "120px",
        },
        {
          title: "修改时间",
          dataIndex: "update_time",
          key: "update_time",
          width: "120px",
        },
        {
          title: "操作",
          key: "action",
          width: "100px",
          scopedSlots: {customRender: "action"}
        }
      ];
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/ai/AGoogleAdslandingPage";
  },
  mounted() {
    this.getList()
  },
  components: {InstructionForm},
  methods: {
    onChange(row) {
      console.log(row)
      let Json = {id: row.id, status: row.status == 1 ? 2 : 1}
      changStatus(API.service.CHANG_STATUS, Json).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    },
    resetSeach() {
      this.loading = true
      this.seach = {
        type: 1,
      }
      this.resetSeachdata=false
      this.getList(1)
    },
    getList(page) {
      let seachData = JSON.parse(JSON.stringify(this.seach))
      API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
        console.log(res.data.data.data )
        this.data = res.data.data.data.data  || res.data.data.data
        this.pagination.total = res.data.data.data.total || 0
        this.pagination.current = page || 1
        this.loading = false

      })
    },
    onShowSizeChange(current, size) {
      this.pagination.pageSize = size
      this.getList(1)
    },
    getDynamicColumns(){
      const type = (this.seach && this.seach.type) || 1;

      if(type ==1){
        return [{
              title: "SEO标题",
              dataIndex: "seo_title_in",
              ellipsis: true,
              key: "seo_title_in",
              width: "150px",
            },
            {
              title: "SEO描述",
              dataIndex: "seo_description_in",
              ellipsis: true,
              key: "seo_description_in",
              width: "200px",
            },
            {
              title: "关键词内容描述",
              dataIndex: "keyword_in",
              ellipsis: true,
              key: "keyword_in"
            },
            {
              title: "产品段落描述",
              dataIndex: "paragraphs_in",
              ellipsis: true,
              key: "paragraphs_in"
            },
            {
              title: "公司介绍内容",
              dataIndex: "company_in",
              ellipsis: true,
              key: "company_in"
            },
            {
              title: "案例描述",
              dataIndex: "case_in",
              ellipsis: true,
              key: "case_in"
            },
            {
              title: "证书描述",
              dataIndex: "cert_in",
              ellipsis: true,
              key: "cert_in"
            },
            {
              title: "公司图片描述",
              dataIndex: "company_image_in",
              ellipsis: true,
              key: "company_image_in"
            },
        ]
      }
      else if(type ==2){
        return [{
              title: "SEO标题",
              dataIndex: "seo_title_in",
              ellipsis: true,
              key: "seo_title_in",
              width: "150px",
            },
            {
              title: "SEO描述",
              dataIndex: "seo_description_in",
              ellipsis: true,
              key: "seo_description_in",
              width: "200px",
            },
            {
              title: "关键词内容描述",
              dataIndex: "keyword_in",
              ellipsis: true,
              key: "keyword_in"
            },
            {
              title: "产品段落描述",
              dataIndex: "paragraphs_in",
              ellipsis: true,
              key: "paragraphs_in"
            },
            {
              title: "案例描述",
              dataIndex: "case_in",
              ellipsis: true,
              key: "case_in"
            },
            {
              title: "解决方案描述",
              dataIndex: "programme_in",
              ellipsis: true,
              key: "programme_in"
            },
            {
              title: "公司介绍内容",
              dataIndex: "company_in",
              ellipsis: true,
              key: "company_in"
            },
            {
              title: "公司图片描述",
              dataIndex: "company_image_in",
              ellipsis: true,
              key: "company_image_in"
            },
        ]
      }
      else if(type ==3){
        return [{
              title: "SEO标题",
              dataIndex: "seo_title_in",
              ellipsis: true,
              key: "seo_title_in",
              width: "150px",
            },
            {
              title: "SEO描述",
              dataIndex: "seo_description_in",
              ellipsis: true,
              key: "seo_description_in",
              width: "200px",
            },
            {
              title: "关键词内容描述",
              dataIndex: "keyword_in",
              ellipsis: true,
              key: "keyword_in"
            },
            {
              title: "产品段落描述",
              dataIndex: "paragraphs_in",
              ellipsis: true,
              key: "paragraphs_in"
            },
            {
              title: "案例描述",
              dataIndex: "case_in",
              ellipsis: true,
              key: "case_in"
            },
            {
              title: "解决方案描述",
              dataIndex: "programme_in",
              ellipsis: true,
              key: "programme_in"
            },
            {
              title: "公司介绍内容",
              dataIndex: "company_in",
              ellipsis: true,
              key: "company_in"
            },
            {
              title: "证书描述",
              dataIndex: "cert_in",
              ellipsis: true,
              key: "cert_in"
            },
            {
              title: "公司图片描述",
              dataIndex: "company_image_in",
              ellipsis: true,
              key: "company_image_in"
            },
        ]
      }
      else if(type ==4){
        return [{
              title: "SEO标题",
              dataIndex: "seo_title_in",
              ellipsis: true,
              key: "seo_title_in",
              width: "150px",
            },
            {
              title: "SEO描述",
              dataIndex: "seo_description_in",
              ellipsis: true,
              key: "seo_description_in",
              width: "200px",
            },
            {
              title: "关键词内容描述",
              dataIndex: "keyword_in",
              ellipsis: true,
              key: "keyword_in"
            },
            {
              title: "解决方案描述",
              dataIndex: "programme_in",
              ellipsis: true,
              key: "programme_in"
            },
        ]
      }
      else if(type ==5){
        return [{
              title: "SEO标题",
              dataIndex: "seo_title_in",
              ellipsis: true,
              key: "seo_title_in",
              width: "150px",
            },
            {
              title: "SEO描述",
              dataIndex: "seo_description_in",
              ellipsis: true,
              key: "seo_description_in",
              width: "200px",
            },
            {
              title: "关键词内容描述",
              dataIndex: "keyword_in",
              ellipsis: true,
              key: "keyword_in"
            },
            {
              title: "产品段落描述",
              dataIndex: "paragraphs_in",
              ellipsis: true,
              key: "paragraphs_in"
            },
            {
              title: "案例描述",
              dataIndex: "case_in",
              ellipsis: true,
              key: "case_in"
            },
            {
              title: "公司图片描述",
              dataIndex: "company_image_in",
              ellipsis: true,
              key: "company_image_in"
            },
        ]
      }
      else if(type ==6){
        return [{
              title: "SEO标题",
              dataIndex: "seo_title_in",
              ellipsis: true,
              key: "seo_title_in",
              width: "150px",
            },
            {
              title: "SEO描述",
              dataIndex: "seo_description_in",
              ellipsis: true,
              key: "seo_description_in",
              width: "200px",
            },
            {
              title: "关键词内容描述",
              dataIndex: "keyword_in",
              ellipsis: true,
              key: "keyword_in"
            },
            {
              title: "解决方案描述",
              dataIndex: "programme_in",
              ellipsis: true,
              key: "programme_in"
            },
            {
              title: "优势介绍内容",
              dataIndex: "advantages_in",
              ellipsis: true,
              key: "advantages_in"
            },
            {
              title: "案例描述",
              dataIndex: "case_in",
              ellipsis: true,
              key: "case_in"
            },
            {
              title: "产品段落描述",
              dataIndex: "paragraphs_in",
              ellipsis: true,
              key: "paragraphs_in"
            },
            {
              title: "公司介绍内容",
              dataIndex: "company_in",
              ellipsis: true,
              key: "company_in"
            },
            {
              title: "证书描述",
              dataIndex: "cert_in",
              ellipsis: true,
              key: "cert_in"
            },
            {
              title: "公司图片描述",
              dataIndex: "company_image_in",
              ellipsis: true,
              key: "company_image_in"
            },
        ]
      }
      else if(type ==7){
        return [{
              title: "着陆页生成关键词匹配指令",
              dataIndex: "instruction_keyword",
              ellipsis: true,
              key: "instruction_keyword"
            },
        ]
      }
      else if(type ==8){
        return [{
              title: "着陆页优化-产品",
              dataIndex: "instruction_product",
              ellipsis: true,
              key: "instruction_product"
            },
        ]
      }
      else if(type ==9){
        return [{
              title: "着陆页优化-产品分类指令（上）",
              dataIndex: "instruction_product_cate",
              ellipsis: true,
              key: "instruction_product_cate"
            },
        ]
      }
      else if(type ==10){
        return [{
              title: "着陆页优化-产品分类指令（下）",
              dataIndex: "instruction_product_cate_footer",
              ellipsis: true,
              key: "instruction_product_cate_footer"
            },
        ]
      }

    }
  }
}
</script>

<style scoped>
.seachBox .seachList .name {
  width: 70px !important;
}

.seachBox .seachList .seachs {
  width: calc(100% - 80px);
}
</style>
